import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  Notification,
  NotificationContent,
} from 'src/app/features/notification/interfaces/notification.interface';
import { NotificationService } from 'src/app/features/notification/services/notification.service';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'fc-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
})
export class NotificationComponent implements OnInit {
  notification?: Notification;
  live = 'live';
  loading: boolean = false;

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private layoutService: LayoutService
  ) {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(false);
      this.layoutService.setMobileLayoutConfig({
        headerNav: {
          backButton: true,
          searchButton: false,
          title: 'Notification',
          cartButton: false,
          notificationButton: false,
          userButton: true,
        },
        bottomNav: {
          visibillity: false,
        },
      });
    }
  }

  ngOnInit(): void {
    this.getNotifications();
  }

  ngOnDestroy(): void {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(true);
      this.layoutService.setDefaultMobileLayoutConfig();
    }
  }

  getNotifications() {
    this.notificationService.getNotifications().subscribe((notification) => {
      this.notification = notification;
    });
  }

  redirect(notification: NotificationContent) {
    const type = notification.data.type;
    if (type === 2 || type === 5 || type === 6 || type === 7) {
      this.router.navigate(['/user/order/view', notification.data.order_id]);
    } else if (type === 8) {
      this.router.navigate([
        '/product/',
        notification.data.product_id,
        { tab: 'discussions' },
      ]);
    } else if (type === 9) {
      this.router.navigate([
        '/beauty-book/view/',
        notification.data.commentable_id,
      ]);
    } else if (type === 10) {
      this.router.navigate([
        '/beauty-book/view/',
        notification.data.likeable_id,
      ]);
    } else if (type === 15 || type === 16 || type === 24) {
      this.router.navigate([
        '/user/checkout/view',
        notification.data.checkout_id,
      ]);
    } else if (type === 21 || type === 22) {
      this.router.navigate(['/user/happy-pay/withdrawal']);
    } else if (type === 18 || type === 19) {
      this.router.navigate(['/user/happy-pay/topup']);
    } else if (type === 23) {
      this.router.navigate(['/user/happy-pay']);
    }
    this.notificationService.markAsRead(notification.id).subscribe((res) => {
      this.notificationService.getNotifications();
    });
  }

  markAllAsRead() {
    this.notificationService.markAllAsRead().subscribe((res) => {
      this.getNotifications();
      console.log('Success');
    });
  }
}
